import { RouterModule, Routes } from '@angular/router';

import { AuthGuardService } from '../shared/services/auth-guard.service';

import { LegalInformationComponent } from './legal-information/legal-information.component';

export const legalInformationRoutes: Routes = [
  {
    path: 'legal-information',
    component: LegalInformationComponent,
    canActivate: [AuthGuardService],
  },
];

export const LegalInformationRouting = RouterModule.forChild(legalInformationRoutes);
